import React from 'react';
import './Footer.css';

function Footer({ onNavigate }) {
  const currentYear = new Date().getFullYear();

  const handleNavClick = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handlePolicyClick = (policy) => {
    if (onNavigate) {
      onNavigate(policy);
    }
  };

  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="footer-container">
          <div className="footer-section">
            <h4>Northstar Bridge Commerce</h4>
            <p>Connecting quality suppliers with trusted wholesale partnerships across the United States.</p>
          </div>

          <div className="footer-section">
            <h4>Navigation</h4>
            <ul className="footer-links">
              <li><button onClick={() => handleNavClick('hero')}>Home</button></li>
              <li><button onClick={() => handleNavClick('about')}>About</button></li>
              <li><button onClick={() => handleNavClick('capabilities')}>Capabilities</button></li>
              <li><button onClick={() => handleNavClick('categories')}>Categories</button></li>
              <li><button onClick={() => handleNavClick('contact')}>Contact</button></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Legal</h4>
            <ul className="footer-links">
              <li><button onClick={() => handlePolicyClick('privacy')}>Privacy Policy</button></li>
              <li><button onClick={() => handlePolicyClick('terms')}>Terms of Service</button></li>
              <li><button onClick={() => handlePolicyClick('compliance')}>Compliance</button></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Contact</h4>
            <p>8 The Green, STE R<br />Dover, DE 19901<br />USA</p>
            <p>
              <a href="tel:+13023858016">+1 302 385 8016</a>
              <br />
              <a href="mailto:contact@northstarbridgeco.com">contact@northstarbridgeco.com</a>
            </p>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {currentYear} Northstar Bridge Commerce LLC. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
